<template>
  <div class="container agencyinfo" @scroll="scroll">
    <van-overlay :show="phoneShow" @click="phoneShow = false">
      <div class="phone-box" @click.stop>
        <div class="phone">{{ guideInfo.phone }}</div>
        <div class="btn-box">
          <div class="btn-cancel" @click="phoneShow = false">取消</div>
          <div
              class="btn-ok"
              @click="call({mobile:guideInfo.phone,name:guideInfo.name}),phoneShow = false"
          >
            <a :href="'tel:'+guideInfo.phone" class="call">呼叫</a>
          </div>
        </div>
      </div>
    </van-overlay>

    <div v-if="isFixed" class="tab-box">
      <!-- <tab :tabList="tabList" :name="'tabtwo'" @onSwitch="tabChangeTwo" ref="child"></tab> -->
    </div>
    <van-list v-model="loading" :finished="finished" finished-text @load="loadMoreDiscuss">
      <div class="head">
        <div v-if="guideInfo.state=='3'" class="head-tag">
          <checkedTag :title="'游云南已上线'" class="mr16"></checkedTag>
        </div>
        <div class="head_btn">
          <div
              v-if="supervisionInfo.id && showThisBtn && supervisionInfo.rectifyStatus !=='guideSuperviseMaterial'"
              class="write"
              @click="$router.push({path:'/guide/supervision', query:{guideId: guideInfo.id,supervisionId: supervisionInfo.id}})"
          >
            + {{
              supervisionInfo.rectifyStatus === 'guideSuperviseNotice' ? '整改方案' :
                  (supervisionInfo.rectifyStatus === 'guideSupervisePlan' ? '整改资料' : '整改通知书')
            }}
          </div>
          <!-- <div
              v-if="showType && isBlacklist==0"
              class="write check"
              @click="$router.push({path:'/guide/guiding', query:{type:'addBlacklist',guideId:guideInfo.id}})"
          >
              + 黑名单

          </div> -->
          <div
              v-if="showType && isBlacklist==0&&guideInfo.state=='3'"
              class="write check"
              @click="$router.push({path:'/guide/guiding', query:{type:'addBlacklist',guideId:guideInfo.id}})"
          >
            + 黑名单

          </div>

        </div>

      </div>
      <!-- 导游信息 -->
      <card>
        <div class="company">
          <div class="info">
            <div class="tit">
              <div class="guide-name">{{ guideInfo.name || guideInfo.NAME }}</div>
              <div class="guide-certificate">{{ guideInfo.certificate }}</div>
            </div>
            <div class="title">
              <div class="desc">
                <div class="txt mr5">{{ guideInfo.sexStr }}</div>
                <div class="txt">{{ guideInfo.nationStr }}</div>
              </div>
              <div class="desc">
                <div class="txt">{{ guideInfo.guideTypeStr }}导游</div>
                <star :num="Number(guideLevelStr)"></star>
              </div>
            </div>
            <div
                v-if="guideInfo.photoPath && guideInfo.photoPath !=='' && guideInfo.photoPath !=='http://images-1254950508.cosgz.myqcloud.com/a4061d82e-214b-4dd7-b3d8-31361432b131.png'"
                :style="'background-image:url(' + guideInfo.photoPath + ');'"
                class="agency-img"
            >
              <p v-if="guideInfo.state=='1'" class="wait"><span>待审核</span></p>
              <p v-else-if="guideInfo.state=='2'" class="reject"><span>不通过</span></p>
              <p v-else-if="guideInfo.state!='3'" class="editing"><span>待上报</span></p>
            </div>
            <div v-else :style="'border: 0'" class="agency-img">
              <p v-if="guideInfo.state=='1'" class="wait"><span>待审核</span></p>
              <p v-else-if="guideInfo.state=='2'" class="reject"><span>不通过</span></p>
              <p v-else-if="guideInfo.state!='3'" class="editing"><span>待上报</span></p>
            </div>
          </div>
          <rline></rline>
          <div @click="phoneShow = true">
            <rowItem :ctnColor="'#666666'" :label="'电话：'">{{ guideInfo.phone }}</rowItem>
          </div>
          <rline></rline>
          <div
              @click="guideInfo.travelId ? goItineraryDetail({path:'/travelAgency/info', query:{id: guideInfo.travelId}}) : ''"
          >
            <rowItem
                :ctnColor="'#666666'"
                :label="'所属旅行社：'"
                :showRight="guideInfo.travelId && true"
                text-align="center"
            >
              <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
                <div>{{ guideInfo.travelName || '暂无信息' }}</div>
                <!-- <div v-if="guideInfo.travelName">
                  <van-button v-if="guideInfo.contractPhoto != null && guideInfo.signing==2" icon="passed" size="mini"
                              style="margin-top: -3px"
                              type="primary">
                    已审核
                  </van-button>
                  <van-popover v-else v-model:show="showPopover" theme="dark">
                    <div style="font-size: 10px;color:white;padding: 0.3rem">
                      该信息由导游本人自主填写
                      请注意核实信息真实性
                    </div>
                    <template #reference>
                      <van-button icon="info-o" size="mini" type="warning" @click="showPopover=!showPopover">
                        未审核
                      </van-button>
                    </template>
                  </van-popover>
                </div> -->
              </div>
            </rowItem>
          </div>
        </div>
      </card>
      <!-- 导游评分 -->
      <card>
        <div
            class="column mt12"
            @click="$router.push({path:'/guide/evaluate', query:{guideId: guideInfo.id}})"
        >
          <div class="s-title">
            <div class="t-text">评分</div>
            <div
                class="t-score"
            >{{ guideMarkData.totalScore ? guideMarkData.totalScore.toFixed(1) : 0.0 }}
            </div>
          </div>
          <div class="s-right">
            <div class="r-text">评分详情</div>
            <img class="r-img" src="../../assets/travelAgency/ic_righticon.png"/>
          </div>
          <!-- <right :title="'评分详情'"></right> -->
        </div>
        <rline></rline>
        <div class="column">
          <div class="title">
            <div class="name score" style="font-weight: 400">
              <rtext
                  :textColor="'#666666'"
                  :textSize="12"
                  class="mr12 s-text"
              >基础执业能力:
                {{ guideMarkData.l2BasicAbilityScore ? guideMarkData.l2BasicAbilityScore.toFixed(1) : 0.0 }}
              </rtext>
              <rtext
                  :textColor="'#666666'"
                  :textSize="12"
                  class="mr12 s-text"
              >执业规范度:
                {{ guideMarkData.l2PractisingStandardScore ? guideMarkData.l2PractisingStandardScore.toFixed(1) : 0.0 }}
              </rtext>
              <rtext
                  :textColor="'#666666'"
                  :textSize="12"
                  class="s-text"
              >游客满意度:
                {{
                  guideMarkData.l2TouristSatisfactionScore ? guideMarkData.l2TouristSatisfactionScore.toFixed(1) : 0.0
                }}
              </rtext>
            </div>
          </div>
        </div>
      </card>
      <!-- 导游 重点关注 -->
      <card v-show="isSupervise != 0">
        <div
            class="column mt12"
            @click="$router.push({path:'/guide/supervision', query:{guideId: guideInfo.id,supervisionId: supervisionInfo.id}})"
        >
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'" :textSize="14" class="mr6">重点关注中</rtext>
            </div>
          </div>
          <right :title="'监管明细'"></right>
        </div>
        <!-- <rline v-if="supervisionInfo.id"></rline> -->
        <rline></rline>
        <div
            v-if="supervisionLogList.length > 0 && supervisionInfo.superviseState === 'new'"
            class="column"
        >
          <div class="title">
            <div class="name">
              <rtext
                  :textColor="'#666666'"
                  :textSize="12"
                  class="mr6"
                  style="font-weight: 400"
              >{{ supervisionLogList[0].createTime }} 开始
              </rtext>
            </div>
          </div>
          <rtext
              :textColor="'#666666'"
              :textSize="12"
              class="mr6"
          >剩余{{ supervisionInfo.daysStr }}
          </rtext>
        </div>
      </card>
      <!-- 导游 黑名单监管 -->
      <card v-show="isBlacklist != 0">
        <div
            class="column mt12"
            @click="$router.push({path:'/guide/blacklist', query:{guideId: guideInfo.id,guideBlackId:guideBlackId,disciplineType:disciplineType1}})"
        >
          <div class="title">
            <div class="name">
              <div class="s-title">
                <div class="t-text">黑名单监管{{ blackInfo.createTime === '' ? '' : '中' }}</div>
                <txtTag
                    v-if="disciplineType"
                    :bgColor="'#FF4D4D'"
                    :border="'#FF4D4D'"
                    :txtColor="'#FFFFFF'"
                    class="scale"
                >{{ disciplineType }}
                </txtTag>
              </div>
              <!-- <rtext
                  :textColor="'#333333'"
                  :textSize="14"
                  class="mr6"
              >黑名单监管{{blackInfo.createTime === ''? '' : '中'}}</rtext>-->
            </div>
          </div>

          <div class="s-right">
            <div class="r-text">监管明细</div>
            <img class="r-img" src="../../assets/travelAgency/ic_righticon.png"/>
          </div>
          <!-- <right :title="'监管明细'"></right> -->
        </div>
        <rline></rline>
        <div v-if="blackInfo.createTime !== ''" class="column">
          <div class="title">
            <div class="name">
              <rtext
                  :textColor="'#666666'"
                  :textSize="12"
                  class="mr6"
                  style="font-weight: 400"
              >{{ blackInfo.createTime }} 开始
              </rtext>
            </div>
          </div>
          <rtext
              :textColor="'#666666'"
              :textSize="12"
              class="mr6"
          >剩余{{ blackInfo.leftTime }}
          </rtext>
        </div>
      </card>
      <div :class="isFixed? 'isFixedtb' : ''" class="tab-box">
        <tab ref="child" :name="'tabtwo'" :tabList="tabList" @onSwitch="tabChangeTwo"></tab>
      </div>

      <!-- 导游 卡片信息 -->
      <card :id="'guide-0'">
        <div class="column mt12">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'" :textSize="14" class="mr6">导游卡证</rtext>
              <span class="txt-desc">（身份证、导游证、资格证、出入境…)</span>
            </div>
          </div>
        </div>
        <div class="data-card-cnt">
          <van-swipe
              :loop="false"
              :show-indicators="false"
              :width="swidth"
              class="swipt"
              indicator-color="white"
              @change="onChange"
          >
            <van-swipe-item v-for="(item,index) in cardList" :key="'info1-'+index">
              <div class="item">
                <img :src="require('@/assets/guideSystem/'+item.img)" class="img"/>
                <div class="tit">{{ item.title }}</div>
                <div class="num mt5">{{ item.num }}</div>
                <div class="time mt16">
                  <span v-if="item.stext.txt" class="txt">{{ item.stext.title }}</span>
                  <span class="txt">{{ item.stext.txt }}</span>
                </div>
                <div class="time mt5">
                  <span v-if="item.etext.txt" class="txt">{{ item.etext.title }}</span>
                  <span class="txt">{{ item.etext.txt }}</span>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <div class="indicators">
            <i
                v-for="(item,index) in cardList"
                :key="index"
                :class="{'indicator-active':index==swipeCurIndex}"
                class="indicator"
            ></i>
          </div>
        </div>
      </card>
      <!-- 导游 其他信息 -->
      <card class="item_type">
        <div class="column mt12">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'" :textSize="14" class="mr6">导游信息</rtext>
            </div>
          </div>
        </div>
        <rline></rline>
        <!-- <listItem :label="'语种'" :color="'#999999'" class="langCn">
            <right
                :txtColor="'#333333'"
                :title="guideInfo.languageCn"
                :rightShow="false"
                :fontSize="14"
            ></right>
        </listItem> -->
        <div class="list_item">
          <p class="type">语种</p>
          <p class="text">{{ guideInfo.languageCn }}</p>
          <!-- <p class="text"></p> -->
        </div>
        <rline v-if="guideInfo.languageCn"></rline>
        <div
            @click="$router.push({path:'/guide/education', query:{educationalLevel:educationalLevel,majorLevel:majorLevel,schoolLevel:schoolLevel}})"
        >
          <listItem :color="'#999999'" :label="'学历信息'">
            <right :fontSize="14" :title="'学历、专业、毕业院校'" :txtColor="'#CCCCCC'"></right>
          </listItem>
        </div>
        <rline></rline>
        <listItem
            v-if="guideInfo.signTime"
            :color="'#999999'"
            :label="'合同签约时间'"
            class="line_bottom"
        >
          <right
              :fontSize="14"
              :rightShow="false"
              :title="guideInfo.signTime"
              :txtColor="'#333333'"
          ></right>
        </listItem>
        <!-- <rline v-if="guideInfo.signTime"></rline> -->
        <listItem v-if="guideInfo.leaderSeniority" :color="'#999999'" :label="'领队资格'">
          <right
              :fontSize="14"
              :rightShow="false"
              :title="guideInfo.leaderSeniority"
              :txtColor="'#333333'"
          ></right>
        </listItem>
        <rline v-if="guideInfo.leaderSeniority"></rline>
        <div class="line_bottom" @click="$router.push(`/guide/areaUpdate?guideId=${id}`)">
          <listItem :color="'#999999'" :label="'所属区域'">
            <right :fontSize="14" :title="guideInfo.address" :txtColor="'#333333'"></right>
          </listItem>
        </div>
        <!-- <rline v-if="guideInfo.skill"></rline> -->
        <listItem v-if="guideInfo.skill" :color="'#999999'" :label="'特长'">
          <right
              :fontSize="14"
              :rightShow="false"
              :title="guideInfo.skill"
              :txtColor="'#333333'"
          ></right>
        </listItem>
        <rline v-if="guideInfo.skill"></rline>
      </card>
      <!-- 证件图片 -->
      <card :id="'guide-1'">
        <div
            class="column mt12"
            @click="credentialsPhoto.count> 0 ?$router.push({path:'/guide/photo'}): ''"
        >
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'" :textSize="14" class="mr6">证件图片</rtext>
            </div>
          </div>

          <div class="s-right">
            <div class="r-text">全部 {{ credentialsPhoto.count }} 条</div>
            <img
                v-if="credentialsPhoto.count > 0"
                class="r-img"
                src="../../assets/travelAgency/ic_righticon.png"
            />
          </div>
        </div>
        <div v-if="credentialsPhoto.count> 0" class="img-list">
          <div
              v-for="(item,index) in credentialsPhoto.list"
              :key="'info2-'+index"
              class="img-block"
          >
            <div v-if="item.photos[0]"
                 class="item">

              <div class="imgs">
                <!-- <img
                    class="img"
                    :src="item.photos[0]?item.photos[0]:'@/assets/travelAgency/ic_bm_cy.png'"
                /> -->
                <img
                    :src="item.photos[0]?item.photos[0]:''"
                    class="img"
                />
                <div class="num">共{{ item.photos.length }}张</div>
              </div>
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </card>
      <!-- 行程单 -->
      <card :id="'guide-2'" class="card-block">
        <div
            class="column mt12 trip-box"
            @click="itineraryTotal>0?goItineraryList({path:'/travelAgency/travelItinerary', query:{guideId: id}}):''"
        >
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'" :textSize="14" class="mr6">行程单</rtext>
            </div>
          </div>

          <div class="s-right">
            <div class="r-text">全部 {{ itineraryTotal }} 条</div>
            <img
                v-if="itineraryTotal > 0"
                class="r-img"
                src="../../assets/travelAgency/ic_righticon.png"
            />
          </div>
          <!-- <right :title="'全部 '+ itineraryTotal +' 条 '" :txtColor="'#333333'" :rightShow="itineraryTotal>0"></right> -->
        </div>
        <div
            v-for="(lists,index) in itineraryList"
            :key="index"
            :style="index===0? 'padding-top: 0;' :''"
            class="list-item-box"
            @click="goItineraryDetail({path:'/travelAgency/tripDetail', query:{tripId: lists.teamNo}})"
        >
          <div class="items-box">
            <div class="info-box">
              <div class="title-box">
                <div class="title">{{ lists.routeName }}</div>
                <div
                    v-if="Date.parse(new Date()) < (Date.parse(lists.teamEndDate))"
                    class="tag"
                >正在出团
                </div>
              </div>
              <div class="date-box">
                <div
                    class="dates"
                >{{ (lists.teamStartDate).substring(0, 10) }} 至 {{ (lists.teamEndDate).substring(0, 10) }}
                </div>
                <div class="address">{{ lists.teamStartPlace }}</div>
              </div>
              <div class="numbers">行程单号 : {{ lists.teamNo }}</div>
            </div>
            <div class="lookmore">
              <img
                  alt
                  class="right-icon"
                  src="../../assets/travelAgency/ic_righticon.png"
              />
            </div>
          </div>
          <rline v-if="index < itineraryList.length - 1"></rline>
        </div>
      </card>
      <!-- 投诉 -->
      <!--            <card :id="'guide-3'">-->
      <!--                &lt;!&ndash; <div-->
      <!--                    class="column mt12"-->
      <!--                    @click="complaintTotal>0?$router.push({path:'/guide/complaintlList', query:{name: guideInfo.name}}):''"-->
      <!--                > &ndash;&gt;-->
      <!--                <div-->
      <!--                    class="column mt12"-->
      <!--                    @click="complaintTotal>0?$router.push({path:'/complaint/guideOrTravelList', query:{type:guide}}):''"-->
      <!--                >-->
      <!--                    <div class="title">-->
      <!--                        <div class="name">-->
      <!--                            <rtext :textColor="'#333333'" :textSize="14" class="mr6">投诉</rtext>-->
      <!--                        </div>-->
      <!--                    </div>-->

      <!--                    <div class="s-right">-->
      <!--                        <div class="r-text">全部 {{complaintTotal || 0}} 条</div>-->
      <!--                        <img-->
      <!--                            class="r-img"-->
      <!--                            src="../../assets/travelAgency/ic_righticon.png"-->
      <!--                            v-if="complaintTotal > 0"-->
      <!--                        />-->
      <!--                    </div>-->
      <!--                    &lt;!&ndash; <right :title="'全部 '+ complaintTotal +' 条 '" :txtColor="'#333333'" :rightShow="complaintTotal>0"></right> &ndash;&gt;-->
      <!--                </div>-->

      <!--                <div v-for="(item,index) in complaintList" :key="'info4-'+index">-->
      <!--                    <div-->
      <!--                        class="info-list"-->
      <!--                        :style="index===0? 'padding-top: 0!important;' :''"-->
      <!--                        @click="goComplainDetail(item)"-->
      <!--                    >-->
      <!--                        <div class="title">-->
      <!--                            <div class="name">{{item.complain_problem}}</div>-->
      <!--                        </div>-->
      <!--                        <div class="desc">-->
      <!--                            <div-->
      <!--                                class="txt"-->
      <!--                            >{{item.complain_time ? item.complain_time.substring(0,10) : ''}}</div>-->
      <!--                        </div>-->
      <!--                        <div class="desc">-->
      <!--                            <div class="txt">{{item.complain_classify}}</div>-->
      <!--                            <div class="d-right">-->
      <!--                                <div class="r-text">{{item.subStatue}}</div>-->
      <!--                                <img class="r-img" src="../../assets/travelAgency/ic_righticon.png" />-->
      <!--                            </div>-->
      <!--                            &lt;!&ndash; <right :txtColor="'#36B374'" :title="item.subStatue"></right> &ndash;&gt;-->
      <!--                        </div>-->
      <!--                    </div>-->
      <!--                    <rline v-if="index < complaintList.length - 1"></rline>-->
      <!--                </div>-->
      <!--            </card>-->
      <!-- 奖惩 -->
      <card :id="'guide-4'">
        <div
            class="column mt12"
            @click="awardTotal > 0 ? $router.push({path:'/guide/infoList', query:{guideId: guideInfo.id}}): ''"
        >
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'" :textSize="14" class="mr6">奖惩信息</rtext>
            </div>
          </div>

          <div class="s-right">
            <div class="r-text">全部 {{ awardTotal }} 条</div>
            <img
                v-if="awardTotal > 0"
                class="r-img"
                src="../../assets/travelAgency/ic_righticon.png"
            />
          </div>
          <!-- <right :title="'全部 '+ awardTotal +' 条 '" :txtColor="'#333333'" :rightShow="awardTotal > 0"></right> -->
        </div>
        <div
            v-for="(item,index) in itemList"
            :key="'info3-'+index"
            :style="index===0? 'padding-top: 0;' :''"
            class="line-item line_bottom"
            @click="item.type==1?$router.push({path:'/guide/awardDetail', query:{info: JSON.stringify(item)}}):$router.push({path:'/guide/penaltyDetail', query:{info: JSON.stringify(item)}})"
        >
          <div
              :class="item.type==1?'award':'penalty'"
              class="l-txt"
          >{{ item.type == 1 ? '奖' : '惩' }}
          </div>
          <div class="r-txt">
            <div class="tit">{{ item.name }}</div>
            <div class="time-warp">
              <div class="tit">{{ item.time ? item.time.substring(0, 10) : '' }}</div>
              <img class="img" src="@/assets/travelAgency/right.png"/>
            </div>
          </div>
        </div>
      </card>
      <!-- 评价 -->
      <card :id="'guide-5'">
        <div class="column mt12 test">
          <div class="title">
            <div class="name">
              <rtext :textColor="'#333333'" :textSize="14" class="mr6">游客评价</rtext>
            </div>
          </div>

          <div class="s-right">
            <div class="r-text">全部 {{ discussTotal }} 条</div>
          </div>
          <!-- <right :title="'全部 '+ discussTotal +' 条 '" :txtColor="'#333333'" :rightShow="false"></right> -->
        </div>
        <div v-for="(item,index) in discussList" :key="'info5-'+index">
          <div :style="index===0? 'padding-top: 0;' :''" class="evaluate">
            <img v-if="item.visitorPic" :src="item.visitorPic" class="img"/>
            <img
                v-if="!item.visitorPic"
                class="img"
                src="@/assets/travelAgency/ic_bm_cy.png"
            />
            <div class="wrap">
              <div class="username">{{ item.name }}</div>
              <div class="cmt-time">
                <div class="txt">{{ item.ctime ? item.ctime.substring(0, 10) : '' }}</div>
                <div class="txt">{{ item.discussFrom ? item.discussFrom : '来自游云南app' }}</div>
              </div>
              <div class="score">
                <div class="tit">讲解水平</div>
                <star
                    :num="Number(item.evaluation.explanation)>5? 5: Number(item.evaluation.explanation)"
                ></star>
              </div>
              <div class="score">
                <div class="tit">服务态度</div>
                <star
                    :num="Number(item.evaluation.service)>5 ? 5: Number(item.evaluation.service)"
                ></star>
              </div>
              <div class="score">
                <div class="tit">仪容仪表</div>
                <star
                    :num="Number(item.evaluation.appearance)>5 ? 5: Number(item.evaluation.appearance)"
                ></star>
              </div>
              <div class="desc">{{ item.opinion }}</div>
            </div>
          </div>
          <rline v-if="index < complaintList.length - 1"></rline>
        </div>
        <!-- <div class="more-data">下滑加载更多</div> -->
      </card>
    </van-list>
    <!-- 审核信息按钮 -->
    <div v-if="guideInfo.state=='1'&&showType1" class="check_btn">
      <!-- <div class="check_btn"> -->
      <span class="s_btn" @click="$router.push(`/guide/noPass?id=${guideInfo.id}&back=${back}`)">审核不通过</span>
      <span class="s_btn f_btn" @click="passConfirm">审核通过</span>
    </div>
  </div>
</template>
<script>
import mixin from '@/mixins/index';
import {mapState} from 'vuex';
import api from '../../service/modules/guide';
import star from 'comps/star';
import tab from '../guideSystem/components/guideTab';
import rtext from '../travelAgency/components/text';
import listItem from './components/list-item';
import rowItem from '../travelAgency/components/list-item';
import card from '../travelAgency/components/card';
import rline from '../travelAgency/components/line';
import checkedTag from '../travelAgency/components/checked-tag';
import right from './components/right';
import txtTag from '../travelAgency/components/txt-tag';
import util from '../../utils/common';
import apimessage from '../../service/modules/message'
import {storageGetByName} from '../../utils/helper'
import {log} from 'util';
import { navigateToItineraryUniversal } from '@/router/navigate';

export default {
  components: {
    star,
    rtext,
    card,
    checkedTag,
    right,
    txtTag,
    rline,
    listItem,
    tab,
    rowItem
  },
  mixins: [mixin],
  data() {
    return {
      id: '',
      // id: '000B22CB16CC40AAA5E4C2A38B7B8537',
      guideInfo: '', // 导游信息
      guideLevelStr: '',
      // 学历
      educationalLevel: '',
      majorLevel: '',
      schoolLevel: '',
      // 导游评分
      guideMarkData: {},
      swipeCurIndex: 0,
      // 导游证号
      certificate: '',
      // van-list
      loading: false,
      finished: false,
      discussList: [],
      discussPage: 1,
      swidth: 280,
      phoneShow: false,
      topList: [],
      tabHeight: '',
      scrollHeight: '',
      isFixed: false,
      active: '',
      cardList: [],
      // tabList: ['信息', '图片', '行程单', '投诉', '奖惩', '评价'],
      tabList: ['信息', '图片', '行程单', '奖惩', '评价'],
      tag: ['分社', '昆明市 五华区 石林县'],
      // 奖惩信息
      itemList: [],
      awardTotal: 0,
      // 证件图片
      credentialsPhoto: {},
      // 重点关注明细
      supervisionInfo: {},
      showThisBtn: false,
      supervisionLogList: [],
      discussTotal: 0,
      // 是不是黑名单或者重点关注
      isBlacklist: 0,
      isSupervise: 0,
      disciplineType: '',
      disciplineType1: '',
      blackInfo: {createTime: '', leftTime: ''},
      // 投诉信息
      complaintList: [],
      complaintTotal: 0,
      // 行程单
      itineraryList: [],
      itineraryTotal: 0,
      tabIndex: 0,
      guideBlackId: '',
      showType: false,
      showType1: false,
      back: this.$route.query.back || '',
      showPopover: false
      // isBlacklist:'',//是否是黑名单
    };
  },

  computed: {
    ...mapState('home', ['contacts'])
  },
  watch: {},

  methods: {
    passConfirm() { // 审核通过
      api.auditYesGuide({id: this.guideInfo.id}).then(res => {
        if (res.ret === 0) {
          this.$Toast.loading({
            message: '审核通过',
            icon: 'passed',
            forbidClick: true
          });
          this.getGuideInfo();
        }
      });
    },
    // 消息单条已读
    onMessageReadOne(isRead, id) {
      if (isRead === 'false') {
        apimessage.messageReadOne({messageId: id}).then(res => {
          localStorage.setItem('messageId', id)
        })
      }
    },
    loadMoreDiscuss() {
      this.getTouristDiscuss();
    },
    onChange(index) {
      this.swipeCurIndex = index;
    },
    // tabChange (idx) {
    //     document.querySelector('.agencyinfo').scrollTop = this.topList[idx] + 60;
    //     // 显示吸顶导航栏
    //     this.isFixed = true;
    //     this.$refs.child.switchTab(idx);
    // },
    tabChangeTwo(idx) {
      // document.querySelector('.agencyinfo').scrollTop = this.topList[idx] + 60;
      document.querySelector('.agencyinfo').scrollTo({
        top: document.querySelector('#guide-' + idx).offsetTop - 60,
        behavior: 'smooth' // 平滑滚动
      });
      // this.$refs.child.defaultIndex(idx);
    },
    getElement() {
      this.tabHeight = document.querySelector(
          '.data-card-tab'
      ).clientHeight;
      this.scrollHeight = document.querySelector(
          '.data-card-tab'
      ).offsetTop;
    },
    scroll(e) {
      let {scrollTop} = e.target;
      var active = 0;
      scrollTop = scrollTop + 80;
      sessionStorage.setItem('guideScrollTop', scrollTop);
      if (scrollTop >= this.scrollHeight) {
        // - this.tabHeight
        // 显示吸顶导航栏
        this.isFixed = true;
        if (this.tabList && this.tabList.length > 0) {
          for (let i = 0; i < this.tabList.length; i++) {
            if (i < this.tabList.length - 1) {
              if (
                  document.querySelector('#guide-' + i).offsetTop <=
                  scrollTop &&
                  scrollTop <=
                  document.querySelector('#guide-' + (i + 1))
                      .offsetTop
              ) {
                active = i;
                break;
              } else {
                active = 0;
              }
            } else if (
                document.querySelector('#guide-' + i).offsetTop <=
                scrollTop
            ) {
              active = i;
            } else {
              active = 0;
            }
          }
          this.tabIndex = active;
          if (this.$refs.child) {
            // 根据active来显示对应的tab激活状态
            this.$refs.child.defaultIndex(active);
          }
        }
      } else {
        active = 0;
        this.tabIndex = active;
        if (this.$refs.child) {
          // 根据active来显示对应的tab激活状态
          this.$refs.child.defaultIndex(active);
        }
        this.isFixed = false;
      }
    },
    test(data) {
      // let a = document.querySelector(".test")
      console.log(data);
      // this.$refs.tabWrapper.scrollToElement(a, 0, 12, 22)
    },
    // 导游评分拉取
    getTouristMark(name, certi) {
      api.guideMark({guideName: name, certificate: certi}).then(res => {
        this.guideMarkData = res.data.list[0] || {
          l2TouristSatisfactionScore: '',
          l2PractisingStandardScore: '',
          l2BasicAbilityScore: '',
          totalScore: ''
        };
      });
    },
    // 导游评论拉取
    getTouristDiscuss() {
      api.guideDiscuss({
        cardNo: this.certificate,
        type: 'guide',
        p: this.discussPage
      }).then(res => {
        this.discussList = this.discussList.concat(res.data.list);
        // 加载状态结束
        this.loading = false;
        this.discussPage += 1;
        this.discussTotal = res.data.pagination.total;
        if (
            this.discussTotal <=
            res.data.pagination.current_page *
            res.data.pagination.page_size
        ) {
          this.finished = true;
        }
      });
    },
    // 导游奖惩信息拉取
    getAwards() {
      this.itemList = [];
      api.guideAwardList({
        guideId: this.guideInfo.id,
        pageSize: 10,
        pageNo: 1
      }).then(res => {
        if (res.ret === 0) {
          let awardsList = []
          this.itemList = []
          res.data.list.forEach(element => {
            element.type = 1
            element.time = this.formatDate(element.awardTime)
            element.name = element.awardDetail === null ? element.awardLevel + element.awardType : element.awardDetail
            awardsList.push(element)
          });
          api.guidePunish({
            guideId: this.guideInfo.id,
            pageSize: 10,
            pageNo: 1
          }).then(res => {
            if (res.ret === 0) {
              res.data.list.forEach(element => {
                element.type = 2
                element.time = this.formatDate(element.decideDate)
                element.name = element.punishMethod === null ? element.punishType : element.punishMethod
                awardsList.push(element)
              });
              awardsList.sort((a, b) => {
                return b.time > a.time ? 1 : -1
              })
              this.awardTotal = awardsList.length
              console.log(awardsList, '---------------awardsList')
              awardsList = awardsList.splice(0, 3)
              this.itemList = awardsList
              console.log(this.itemList, '----------------itemList.splice(3)')
            }
          });
        }
      });
    },
    // 时间戳转日期
    formatDate(timestamp) {
      var time = new Date(timestamp);
      var y = time.getFullYear();
      var m =
          time.getMonth() + 1 < 10
              ? '0' + (time.getMonth() + 1)
              : time.getMonth() + 1;
      var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
      var h =
          time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
      var mm =
          time.getMinutes() < 10
              ? '0' + time.getMinutes()
              : time.getMinutes();
      let date = y + '-' + m + '-' + d + ' ' + h + ':' + mm;
      return date;
    },
    // 导游重点关注信息拉取
    getSupervision() {
      api.querySupervisionByGuideId({
        guideId: this.guideInfo.id
      }).then(res => {
        if (res.ret === 0 && res.data) {
          this.supervisionInfo = res.data.supervisionInfo || {};
          this.showThisBtn = true
          this.supervisionLogList = res.data.supervisionLogList || [];
        }
      });
    },
    // 导游黑名单监管信息拉取
    getBlacklistMessage() {
      this.blackInfo = {createTime: '', leftTime: ''};
      api.getBlacklistMessage({guideId: this.id}).then(res => {
        if (res.ret === 0) {
          res.data.blacklist.forEach(item => {
            if (item.recordState === 1) {
              this.blackInfo = item;
              this.guideBlackId = item.id;
            }
          });
        }
      });
    },
    // 拉取投诉列表
    getComplaint() {
      api.getComplaint({
        p: 1,
        pageSize: 3,
        name: this.guideInfo.name
      }).then(res => {
        if (res.ret === 0) {
          this.complaintList = (res.data && res.data.list) || [];
          // console.log('<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<');
          // console.log(res.data);
          this.complaintTotal = res.data.totalSize;
        }
      });
    },
    goComplainDetail(value) {
      this.$store.commit('complaint/setHandleWorkbench', false);
      util.setJsonLocal('item', value);
      this.$store.commit('complaint/getItemList', value);
      console.log(value);
      this.goRoute(value);
    },
    goRoute(value) {
      window.yyn.invokeJSB(
          'openWindow',
          {
            openUrl: `${
                this.globalApp.getSystemInfo().host
            }web/#/complaint/detailList/complaintSheet`,
            isFullScreen: 0,
            setTitle: '',
            needLoading: 1
          },
          cb => {
            console.log(cb, 'callback');
          }
      );
    },
    // 拉取行程单列表
    getItinerary() {
      api.queryItinerary({guideId: this.guideInfo.id}).then(res => {
        this.itineraryList = [];
        if (res.ret === 0) {
          res.data.list.forEach(item => {
            if (this.itineraryList.length < 3) {
              this.itineraryList.push(item);
            }
          });
          this.itineraryTotal = res.data.pagination.total;
          // this.itineraryList.push
        }
      });
    },
    goItineraryList(params) {
      console.log(params)
      let value = params.query;
      let str = [];
      for (let key in value) {
        str.push(key + '=' + value[key]);
      }
      let query = str.join('&');
      window.yyn.invokeJSB(
          'openWindow',
          {
            openUrl: `${this.globalApp.getSystemInfo().host}web/#${
                params.path
            }?${query}`,
            isFullScreen: 0,
            setTitle: '',
            needLoading: 1
          },
          cb => {
            console.log(cb, 'callback');
          }
      );
    },
    goItineraryDetail(params) {
      console.log(params)
      let value = params.query;
      // let str = [];
      // for (let key in value) {
      //   str.push(key + '=' + value[key]);
      // }
      // let query = str.join('&');
      // window.yyn.invokeJSB(
      //     'openWindow',
      //     {
      //       openUrl: `${this.globalApp.getSystemInfo().host}web/#${
      //           params.path
      //       }?${query}`,
      //       isFullScreen: 0,
      //       setTitle: '',
      //       needLoading: 1
      //     },
      //     cb => {
      //       console.log(cb, 'callback');
      //     }
      // );
      navigateToItineraryUniversal(value.tripId, 'team-supervision')
    },
    // 判断旅行社是否有数据
    getInitData() {
      api
          .getTravelDetail({id: this.guideInfo.travelId})
          .then(res => {
            if (res.ret === 0) {
              if (!res.data.travelAgencyDetails) {
                // this.guideInfo.travelId = null;
              }
            }
          });
    },
    // 拉取导游详情
    getGuideInfo() {
      api.guideInfo({id: this.id}).then(res => {
        console.log(res)
        if (res.ret === 0) {
          this.guideInfo = res.data;
          if (this.guideInfo.travelId) {
            this.getInitData();
          }

          this.isBlacklist = res.data.isBlacklist;
          this.disciplineType1 = res.data.disciplineType;
          if (res.data.disciplineType === 'national') {
            this.disciplineType = '全国惩戒'
          } else if (res.data.disciplineType === 'provincial') {
            this.disciplineType = '全省惩戒'
          } else if (res.data.disciplineType === 'city') {
            this.disciplineType = '州市级惩戒'
          } else {
            this.disciplineType = ''
          }
          // 拉取奖惩信息
          this.getAwards();
          this.supervisionInfo = {};
          this.supervisionLogList = [];
          if (this.isSupervise !== 0) {
            // 拉取重点关注信息
            this.getSupervision();
          }
          this.blackInfo = {createTime: '', leftTime: ''};
          if (this.isBlacklist !== '0') {
            // 拉取黑名单监管信息
            this.getBlacklistMessage();
          }
          // 拉取导游评分
          this.getTouristMark(res.data.name, res.data.certificate);
          // 拉取导游详情
          this.certificate = res.data.certificate;
          // 拉去导游评论
          this.discussList = [];
          this.discussTotal = 0;
          this.discussPage = 1;
          this.loading = false;
          this.finished = false;
          // this.getTouristDiscuss();
          // 拉取投诉信息
          // this.getComplaint();
          // 拉取行程单数据
          this.getItinerary();
          // 处理星级
          if (res.data.guideLevelStr === '一星级') {
            this.guideLevelStr = 1;
          } else if (res.data.guideLevelStr === '二星级') {
            this.guideLevelStr = 2;
          } else if (res.data.guideLevelStr === '三星级') {
            this.guideLevelStr = 3;
          } else if (res.data.guideLevelStr === '四星级') {
            this.guideLevelStr = 4;
          } else if (res.data.guideLevelStr === '五星级') {
            this.guideLevelStr = 5;
          }
          // 处理学历
          if (res.data.educationalLevel === '01') {
            this.educationalLevel = '初中';
          } else if (res.data.educationalLevel === '02') {
            this.educationalLevel = '高中';
          } else if (res.data.educationalLevel === '03') {
            this.educationalLevel = '中专';
          } else if (res.data.educationalLevel === '04') {
            this.educationalLevel = '中技';
          } else if (res.data.educationalLevel === '05') {
            this.educationalLevel = '大专';
          } else if (res.data.educationalLevel === '06') {
            this.educationalLevel = '本科';
          } else if (res.data.educationalLevel === '07') {
            this.educationalLevel = '硕士';
          } else if (res.data.educationalLevel === '08') {
            this.educationalLevel = '博士';
          }
          if (res.data.schoolLevel) {
            this.schoolLevel = res.data.schoolLevel;
          }
          if (res.data.signTime) {
            this.signTime = res.data.signTime;
          }
          // 处理各种证
          this.cardList = [];
          if (res.data.idCard) {
            this.cardList.push({
              title: '身份证',
              num: res.data.idCard,
              img: 'bg_shengfenzheng@2x.png',
              stext: {
                title: '出生日期',
                txt: res.data.birthDay || res.data.birthday || ''
              },
              etext: {
                title: '有效期至',
                txt: res.data.idOutDate || ''
              }
            });
          }
          if (res.data.certificate) {
            this.cardList.push({
              title: '导游证',
              num: res.data.certificate,
              img: 'bg_daoyou@2x.png',
              stext: {
                title: '',
                txt: ''
              },
              etext: {
                title: '发证日期',
                txt: res.data.touristGetDate || ''
              }
            });
          }
          if (res.data.qualification) {
            this.cardList.push({
              title: '资格证',
              num: res.data.qualification,
              img: 'bg_zigezheng@2x.png',
              stext: {
                title: '发证机关',
                txt: res.data.qualificationGetAddress || ''
              },
              etext: {
                title: '发证日期',
                txt: res.data.qualificationGetDate || ''
              }
            });
          }
          if (res.data.passportNo) {
            this.cardList.push({
              title: '护照',
              num: res.data.passportNo,
              img: 'bg_huzhao@2x.png',
              stext: {
                title: '签发地',
                txt: res.data.passportGetAddressStr || ''
              },
              etext: {
                title: '有效期至',
                txt: res.data.passportOutDate || ''
              }
            });
          }
          if (res.data.hongkongNo) {
            this.cardList.push({
              title: '港澳通行证',
              num: res.data.hongkongNo,
              img: 'bg_gangao@2x.png',
              stext: {
                title: '签发地',
                txt: res.data.hongkongGetAddressStr || ''
              },
              etext: {
                title: '有效期至',
                txt: res.data.hongkongOutDate || ''
              }
            });
          }
          if (res.data.burmaNo) {
            this.cardList.push({
              title: '缅甸边境通行证',
              num: res.data.burmaNo,
              img: 'bg_miandian@2x.png',
              stext: {
                title: '签发地',
                txt: res.data.burmaGetAddressStr || ''
              },
              etext: {
                title: '有效期至',
                txt: res.data.burmaOutDate || ''
              }
            });
          }
          if (res.data.taiwanNo) {
            this.cardList.push({
              title: '赴台证',
              num: res.data.taiwanNo,
              img: 'bg_tai@2x.png',
              stext: {
                title: '签发地',
                txt: res.data.taiwanGetAddressStr || ''
              },
              etext: {
                title: '有效期',
                txt: res.data.taiwanOutDate || ''
              }
            });
          }
          // 证件图片
          this.credentialsPhoto = res.data.credentialsPhoto || {
            count: 0,
            list: []
          };
          localStorage.setItem('credentialsPhoto', JSON.stringify(this.credentialsPhoto.list))
          // 专业
          this.majorLevel = res.data.majorLevel
          // console.log('导游详情:', this.guideInfo)
        }
      });
    }
  },

  async mounted() {
    this.id = this.$route.query.guideId || '';
    this.isBlacklist = this.$route.query.isBlacklist || 0;
    this.isSupervise = this.$route.query.isSupervise || 0;
    if (this.$route.query.disciplineType === 'national') {
      this.disciplineType = '全国惩戒'
    } else if (this.$route.query.disciplineType === 'provincial') {
      this.disciplineType = '全省惩戒'
    } else if (this.$route.query.disciplineType === 'city') {
      this.disciplineType = '州市级惩戒'
    }
    console.log('aaaa333333333333333:', this.disciplineType)
    this.swidth = (280 * window.innerWidth) / 375;
    window.addEventListener('scroll', this.scroll);
    this.getGuideInfo();
    this.$refs.child.defaultIndex(0);
    setTimeout(() => {
      this.getElement();
    }, 1000);
    this.$store.dispatch('home/loadContacts');
    // 获取guideInfoObj
    let res = await storageGetByName('guideInfoObj')
    let isTpyeName = res.OrgInfo.orgRegionId
    // let isTpyeName = JSON.parse(localStorage.getItem('guideInfoObj')).OrgInfo.orgRegionId
    if (isTpyeName !== '34') {
      this.showType = true;
      this.showType1 = true
    } else if (isTpyeName === '34') {
      // this.showType1 = true
    }
    // this.isFixed = false
  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    next(vm => {
          // 通过 `vm` 访问组件实例
          if (
              from.path === '/guide/guideList' ||
              from.path === '/guide/search' || from.path == '/guide/exitBlackList' || from.path == '/guide/guiding'
          ) {
            vm.isFixed = false;
            // 一定是从A进到B页面才刷新
            vm.id = vm.$route.query.guideId || '';
            vm.isBlacklist = vm.$route.query.isBlacklist || 0;
            vm.isSupervise = vm.$route.query.isSupervise || 0;
            if (vm.$route.query.disciplineType === 'national') {
              vm.disciplineType = '全国惩戒'
            } else if (vm.$route.query.disciplineType === 'provincial') {
              vm.disciplineType = '全省惩戒'
            } else if (vm.$route.query.disciplineType === 'city') {
              vm.disciplineType = '州市级惩戒'
            }
            vm.swidth = (280 * window.innerWidth) / 375;
            window.addEventListener('scroll', vm.scroll);
            vm.getGuideInfo();
            window.scrollTo(0, 0);
            setTimeout(() => {
              vm.getElement();
            }, 1000);
          } else {
            window.addEventListener('scroll', vm.scroll);
            let scrollTop = sessionStorage.getItem('guideScrollTop');
            // document.querySelector('.agencyinfo').scrollTo({
            window.scrollTo({
              top: scrollTop
              // behavior: 'smooth' // 平滑滚动
            });
            // vm.tabChangeTwo(vm.tabIndex)
          }
        }
    );
  },

  created() {
    let messageId = this.$route.query.messageId || ''
    let isRead = this.$route.query.isRead || 'true'
    this.onMessageReadOne(isRead, messageId)

    this.$store.dispatch('guide/loadKeyword'); // 搜索key
    this.$store.dispatch('guide/loadHistory'); // 搜索结果
  }
};
</script>
<style lang="less" scoped>
.mr12 {
  margin-right: 12px;
}

.mr8 {
  margin-right: 8px;
}

.card-block {
  min-height: 61px;
}

.data-card-cnt {
  .indicators {
    display: flex;
    justify-content: center;
    align-items: center;
    // height: 24px;
    padding: 12px 0 16px 0;

    .indicator {
      width: 3px;
      height: 2px;
      background: rgba(86, 191, 138, 0.4);
      transition: opacity 0.2s;

      &-active {
        width: 7px;
        height: 4px;
        background-color: #36b374;
      }

      &:not(:last-child) {
        margin-right: 4px;
      }
    }
  }

  .swipt {
    height: 122px;

    .item {
      position: relative;
      box-sizing: border-box;
      width: 266px;
      height: 122px;
      padding: 16px;
      margin-left: 16px;

      .tit {
        color: rgba(255, 255, 255, 1);

        font-family: PingFang SC, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        font-size: 16px;
        font-weight: 500;
      }

      .num {
        color: rgba(255, 255, 255, 1);

        font-size: 14px;
        font-weight: 400;
      }

      .time {
        color: rgba(255, 255, 255, 1);

        font-size: 12px;
        font-weight: 400;

        .txt {
          display: inline-block;
          margin-right: 4px;
        }
      }

      .img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
        border-radius: 3px;
      }
    }
  }
}

.container {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 60px;

  .phone-box {
    width: 260px;
    height: 144px;
    background: rgba(255, 255, 255, 1);
    border-radius: 3px;
    box-sizing: border-box;
    padding: 0 16px 16px 16px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;

    .phone {
      font-size: 18px;

      font-family: PingFang SC, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 90px;
      text-align: center;
    }

    .btn-box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn-cancel,
      .btn-ok {
        width: 110px;
        height: 38px;
        border-radius: 2px;
        border: 1px solid rgba(204, 204, 204, 1);
        text-align: center;
        font-size: 14px;

        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 38px;
      }

      .btn-ok {
        background: #36b374;
        color: #fff;
        border: none;
      }

      .call {
        color: #ffffff;
        width: 110px;
        height: 38px;
        display: block;
      }
    }
  }

  box-sizing: border-box;
  padding: 12px;
  background-color: @base-bgcolor;

  .line-item {
    display: flex;
    padding: 16px;

    .l-txt {
      width: 18px;
      height: 16px;
      margin-right: 8px;
      color: #fff;
      line-height: 16px;
      text-align: center;
      border-radius: 1px;
    }

    .award {
      background: rgba(54, 179, 116, 1);
    }

    .penalty {
      background: #ff4d4d;
    }

    .r-txt {
      flex: 1;

      .tit {
        color: rgba(51, 51, 51, 1);

        font-size: 14px;
        font-weight: 400;
      }

      .time-warp {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 12px;

        .tit {
          color: rgba(153, 153, 153, 1);

          font-size: 12px;
          font-weight: 400;
        }

        .img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }

  .head {
    display: flex;
    justify-content: space-between;
    padding-top: 4px;

    .head-tag {
      display: flex;
      align-items: center;
    }

    .head_btn {
      display: flex;
      flex-direction: row;
      align-items: center;

      .write {
        width: 88px;
        height: 28px;
        background: rgba(54, 179, 116, 1);
        border-radius: 1px;
        line-height: 28px;
        text-align: center;
        font-size: 12px;
        font-weight: 500;
        color: #fff;
        margin-left: 8px;
      }

      .check {
        width: 64px;
      }
    }

  }

  .tab-box {
    padding-top: 12px;
    // margin-top: 12px;
    height: 55px;
    // display: flex;
    // justify-content: flex-end;
    // padding-bottom: 12px
  }

  .check_btn {
    width: 100%;
    height: 60px;
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    box-sizing: border-box;
    z-index: 2;

    .s_btn {
      width: 165px;
      height: 40px;
      display: inline-block;
      text-align: center;
      line-height: 40px;
      border: 1px solid #36B374;
      border-radius: 3px;
      font-size: 17px;
      color: #36B374;
    }

    .f_btn {
      background-color: #36B374;
      color: #fff;
    }
  }

  .isFixedtb {
    // margin-top: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fbfbfb;
    box-sizing: border-box;
    padding: 0 12px;
    z-index: 99999;
  }

  .company {
    margin-top: 14px;

    .info {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 16px 16px 16px;
      // height: 64px;
      position: relative;

      .tit {
        min-width: 450px;
        color: rgba(51, 51, 51, 1);
        font-family: PingFang SC, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        font-size: 40px;
        font-weight: bold;
        line-height: 60px;
        display: flex;
        align-items: center;
        height: 60px;
        transform: scale(0.5);
        transform-origin: 0;
        position: absolute;
        top: 0;
        // left: -28%;
        .guide-name {
        }

        .guide-certificate {
          padding: 0 8px;
          height: 40px;
          font-size: 20px;
          color: rgba(54, 179, 116, 1);
          border-radius: 1px;
          border: 1px solid rgba(54, 179, 116, 1);
          line-height: 40px;
          margin-left: 8px;
        }
      }

      .title {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        height: 66px;

        .desc {
          display: flex;
          align-items: center;

          .txt {
            color: rgba(153, 153, 153, 1);

            font-size: 12px;
            font-weight: 400;
          }

          .star {
            display: flex;
            align-items: center;
            height: 16px;
            margin-left: 4px;

            .img {
              width: 8px;
              height: 8px;
              margin-right: 2px;
              object-fit: cover;
              margin-bottom: 2px;
            }
          }
        }

        .desc:first-child {
          margin-bottom: 8px;
        }
      }

      .agency-img {
        // object-fit: cover;
        width: 64px;
        height: 64px;
        background: url(../../assets/travelAgency/ic_bm_cy1.png);
        border-radius: 3px;
        border: 1px solid rgba(238, 238, 238, 1);
        background-size: auto 100%;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;

        .wait {
          position: absolute;
          left: -0.5px;
          bottom: 0;
          width: 64.5px;
          height: 18px;
          background-color: #36B374;
          text-align: center;
          line-height: 18px;
          color: #fff;
          border-radius: 0 0 3px 3px;
          font-size: 0;

          span {
            display: inline-block;
            font-size: 11px;
            transform: scale(0.9);
          }
        }
        .reject {
          position: absolute;
          left: -0.5px;
          bottom: 0;
          width: 64.5px;
          height: 18px;
          background-color: #ff000088;
          text-align: center;
          line-height: 18px;
          color: #fff;
          border-radius: 0 0 3px 3px;
          font-size: 0;

          span {
            display: inline-block;
            font-size: 11px;
            transform: scale(0.9);
          }
        }
        .editing {
          position: absolute;
          left: -0.5px;
          bottom: 0;
          width: 64.5px;
          height: 18px;
          background-color: #6c606088;
          text-align: center;
          line-height: 18px;
          color: #fff;
          border-radius: 0 0 3px 3px;
          font-size: 0;

          span {
            display: inline-block;
            font-size: 11px;
            transform: scale(0.9);
          }
        }
      }
    }
  }

  .trip-box {
    padding: 16px 16px 0 !important;
  }

  .item_type {
    .list_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 12px 16px;
      // justify-content: space-between;
      .type {
        font-size: 14px;
        width: 110px;
        color: rgb(153, 153, 153);
      }

      .text {
        width: 63%;
        line-height: 1.3em;
        font-size: 14px;
        color: rgb(153, 153, 153);
        text-align: right;
      }
    }
  }

  .column {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    min-height: 45px;
    padding: 16px;

    .title {
      display: flex;
      align-items: center;
      font-size: 14px;

      .name {
        display: flex;
        align-items: center;
        width: 100%;
        font-weight: bold;

        .scale {
          transform: scale(0.5);
          transform-origin: left center;
        }

        .num {
          font-family: PingFangSC-Regular, PingFang SC;
          -webkit-font-smoothing: antialiased;
        }

        &.score {
          justify-content: flex-start;
          flex-wrap: wrap;

          .s-text {
            line-height: 20px;
          }
        }

        .txt-desc {
          color: #999;

          font-family: PingFang SC, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }

    .s-title {
      display: flex;
      align-items: center;
      // height: 24px;
      .t-text {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
        margin-right: 8px;
      }

      .t-score {
        color: #36b374;
        font-size: 16px;
        font-family: DIN-Bold, DIN;
        font-weight: bold;
      }
    }

    .s-right {
      display: flex;
      align-items: center;

      .r-text {
        font-size: 12px;
        height: 12px;
        font-family: PingFang SC, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: 400;
        color: #333333;
        line-height: 12px;
        margin-right: 4px;
        // background: orange;
        // display: table-cell;
        // vertical-align: middle;
        // text-align: right;
        // position: absolute;
        // top: 6px;
        // right: 16px;
      }

      .r-img {
        width: 12px;
        object-fit: cover;
        display: block;
        // height: 12px;
        // background: url("../../assets/travelAgency/ic_righticon.png")
        // center center;
        // background-size: 100% 100%;
        // position: absolute;
        // top: 6px;
        // right: 0;
      }
    }
  }

  // .langCn {
  //     .right {
  //         height: 100%;
  //     }
  // }

  .personal {
    display: flex;
    overflow: scroll;

    .item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 36px;
      height: 95px;
      margin-right: 16px;
      margin-left: 16px;

      .img {
        width: 31px;
        height: 36px;
      }

      .name {
        position: absolute;
        top: 46px;
        left: 50%;
        width: 60px;
        color: rgba(102, 102, 102, 1);

        font-size: 14px;
        font-weight: 400;
        text-align: center;
        transform: translateX(-50%);
      }

      .desc {
        position: absolute;
        top: 66px;
        left: 50%;
        width: 60px;
        color: rgba(153, 153, 153, 1);

        font-size: 12px;
        font-weight: 400;
        text-align: center;
        transform: translateX(-50%);
      }
    }
  }

  .img-list {
    display: flex;
    overflow: scroll;

    .img-block {
      &:first-child {
        .item {
          margin-left: 16px;
        }
      }
    }

    .item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 124px;
      height: 163px;
      margin-right: 13px;
      // margin-left: ;

      .imgs {
        position: relative;
        width: 124px;
        height: 124px;
        border-radius: 3px;

        .img {
          width: 100%;
          height: 100%;
          border-radius: 3px;
        }

        .num {
          position: absolute;
          right: 0;
          bottom: 0;
          box-sizing: border-box;
          width: 57px;
          height: 27px;
          padding: 4px 10px;
          color: rgba(255, 255, 255, 1);

          font-family: PingFang SC, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 3px 0 0 0;
        }
      }

      .name {
        position: absolute;
        top: 133px;
        left: 50%;
        width: 130px;
        color: rgba(102, 102, 102, 1);

        font-size: 14px;
        font-weight: 400;
        text-align: center;
        transform: translateX(-50%);
      }
    }
  }

  .info-list {
    padding: 16px 16px 8px 16px;
    // &:first-child {
    //     padding-top: 0;
    // }
    &:last-child {
      border: 0;
    }

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .name {
        margin-right: 16px;
        color: rgba(51, 51, 51, 1);

        font-size: 14px;
        font-weight: 400;
      }
    }

    .desc {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;

      .txt {
        color: rgba(153, 153, 153, 1);

        font-size: 12px;
        font-weight: 400;
      }

      .r-img {
        width: 12px;
        object-fit: cover;
        display: block;
      }

      .d-right {
        display: flex;
        align-items: center;

        .r-text {
          font-size: 12px;
          height: 12px;
          font-family: PingFang SC, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          font-weight: 400;
          color: #36b374;
          line-height: 12px;
          margin-right: 4px;
        }

        .r-img {
          width: 12px;
          object-fit: cover;
          display: block;
        }
      }
    }
  }

  .evaluate {
    display: flex;
    // padding-right: 16px;
    // padding-left: 16px;
    padding: 16px;

    .img {
      width: 36px;
      height: 36px;
      margin-right: 12px;
    }

    .wrap {
      width: 100%;

      .username {
        color: rgba(51, 51, 51, 1);

        font-size: 14px;
        font-weight: 400;
      }

      .cmt-time {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;

        .txt {
          color: rgba(153, 153, 153, 1);

          font-size: 12px;
          font-weight: 400;
        }
      }

      .score {
        display: flex;
        align-items: center;
        height: 16px;
        margin-top: 4px;

        .tit {
          margin-right: 4px;
          color: rgba(153, 153, 153, 1);

          font-size: 12px;
          font-weight: 400;
        }

        .star {
          display: flex;
          align-items: center;
          height: 16px;

          .img {
            width: 8px;
            height: 8px;
            margin-right: 2px;
          }
        }
      }

      .desc {
        margin-top: 14px;
        color: rgba(51, 51, 51, 1);

        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
      }
    }
  }

  .more-data {
    height: 50px;
    color: rgba(153, 153, 153, 1);

    font-size: 12px;
    font-weight: 400;
    line-height: 50px;
    text-align: center;
  }

  .personal::-webkit-scrollbar {
    display: none;
  }

  .img-list::-webkit-scrollbar {
    display: none;
  }

  .list-item-box {
    box-sizing: border-box;
    padding: 0 12px;
    background: #fff;
  }

  .items-box {
    box-sizing: border-box;
    padding: 16px 0;
    display: flex;
    align-items: flex-end;

    .info-box {
      flex: 1;

      .title-box {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 18px;
          margin-right: 12px;
        }

        .tag {
          background: rgba(54, 179, 116, 1);
          border-radius: 1px;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 12px;
          box-sizing: border-box;
          padding: 0 4px;
        }
      }

      .date-box {
        display: flex;
        align-items: center;
        margin-bottom: 4px;

        .dates {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
          margin-right: 12px;
        }

        .address {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
        }
      }

      .numbers {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }
    }

    .lookmore {
      height: 12px;
      display: flex;
      align-items: center;
      overflow: hidden;

      .right-icon {
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
